import { IPrivateFunctionDiaryItem, IServiceItem } from 'shared-types/SharedTypes';
// import EventsService from 'app/services/events/events.service';
import { IBookingService } from 'external-services/booking-generator-service/types';
import EventsLookupService from 'external-services/events-lookup-service';

const NS = 'BookingGeneratorService';

class BookingGeneratorService {
  public makeBookingService(service: IServiceItem): IBookingService {
    const bookingService = {
      service: service,
      bookings: [] as any[],
      covers: EventsLookupService.isPrivateFunEvent(service)
        ? Number((service as IPrivateFunctionDiaryItem).people)
        : 0,
      bookingsCount: 0,
    };

    return bookingService;
  }
}

const instance = new BookingGeneratorService();
export default instance as BookingGeneratorService;
